export default __webpack_public_path__ + "static/media/lifebar0.fac0dbe6.PNG";